module.exports = __webpack_public_path__ + "img/katarina_outside_9.4910a4eb.jpg";